<template>
  <v-form ref="form">
    <v-card>
    <v-card-text class="operator-form__content">
      <div class="title text--primary">
        Terms of purchase
      </div>
      <v-textarea
      v-model="ownOperator.terms_text"
      :readonly="!ownOperator.terms_custom"
      value="Terms of purchase text."
      ></v-textarea>
      <v-card-actions>
        <v-btn color="primary" depressed @click.stop="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card-text>
    </v-card>
  </v-form>
</template>

<style>
.v-textarea textarea[readonly="readonly"] {
    background-color: #f0f0f0;
    color: gray;
}
</style>

<script>
export default {
  props: ['ownOperator'],
  data: function () {
    return {
      typeOf: typeof this.ownOperator
    }
  },
  computed: {
  },
  methods: {
    closeDialog () {
      this.$emit('close-terms-form');
    }
  },
  mounted () {
  },
  components: {
  }
}
</script>
